import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";
import "./style.css";
function LandingPage() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const moduleNamePural = "Landing Page Form";
  const base_url = config.api_url + "admin/leads/landing-page"; //without trailing slash
  const image_url = config.azure_object_url + "public/uploads/landing-page/"; //with trailing slash

  const { Link } = Anchor;

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      setdraweropen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const fetchDatas = async () => {
    setloading(true);
    const data = await http.get(base_url);

    if (data) {
      setDatas(data.data);
    }
    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },

    {
      title: "Created At",
      render: (text, record) => {
        return helper.ISTDate(record.createdAt);
      },
      key: "createdAt",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              handleView(record._id);
            }}
          >
            View Detail
          </Button>
        </Space>
      ),
    },
  ];

  const fields: ITableExportFields = {
    name: "Name",
    email: "Email",
    phone: "Phone",
    gender: "Gender",
    age: "Age",
    contest_learning: "Where did you learn about this contest?",
    fav_product: "Which is your favorite Laxmi Product?",
    product_want: "Which product you want to see from Laxmi?",
    story: "Story",

    media: {
      header: "Media",
      formatter: (_fieldValue, record) => {
        return image_url + record.media;
      },
    },

    consent: {
      header: "Consent",
      formatter: (_fieldValue, record) => {
        return _fieldValue ? "Yes" : "No";
      },
    },
    createdAt: {
      header: "Created At",
      formatter: (_fieldValue, record) => {
        return helper.ISTDate(record.createdAt);
      },
    },
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                exportableProps={{
                  showColumnPicker: true,
                  fields,
                  fileName: moduleNamePural,
                }}
                searchable
              />
            </Card>

            <Drawer
              title="Lead Details"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
            >
              {data && (
                <Descriptions
                  bordered
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="Name">
                    {data.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {data.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Phone">
                    {data.phone}
                  </Descriptions.Item>
                  <Descriptions.Item label="Gender">
                    {data.gender}
                  </Descriptions.Item>
                  <Descriptions.Item label="Age">{data.age}</Descriptions.Item>
                  <Descriptions.Item label="Where did you learn about this contest?">
                    {data.contest_learning}
                  </Descriptions.Item>
                  <Descriptions.Item label="Which is your favorite Laxmi Product?">
                    {data.fav_product}
                  </Descriptions.Item>
                  <Descriptions.Item label="Which product you want to see from Laxmi?">
                    {data.product_want}
                  </Descriptions.Item>
                  <Descriptions.Item label="Story">
                    {data.story || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Photo/Video">
                    <a href={image_url + data.media} target="_blank">
                      View Media
                    </a>
                  </Descriptions.Item>
                  <Descriptions.Item label="Consent">
                    <Tag color={data.consent ? "green" : "red"}>
                      {data.consent ? "Yes" : "No"}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {helper.ISTDate(data.createdAt)}
                  </Descriptions.Item>
                </Descriptions>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default LandingPage;
